import ActionBtn from "components/buttons/ActionBtn";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "components/table/Table";
import EmptyState from "components/EmptyState/EmptyState";
import { useLocation, useNavigate } from "react-router-dom";
import { ModalTypes } from "configs/types";
import { useDispatch } from "react-redux";
import { openModal } from "store/modals/slice";
import { getChannels } from "services/support/channelsService";
import DataTableSkeleton from "components/global/Skeleton/TableSkeleton/DataTableSkeleton";
import { RefreshButton } from "components/buttons/RefreshButton";

export type Channel = {
  id: number;
  title: string;
  type: "chat" | "email";
  isActive: boolean;
};

const ChannelsList = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [list, setList] = useState<Channel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const fetchChannels = async () => {
    setIsLoading(true);

    try {
      const result = await getChannels();
      setList(result);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    fetchChannels();
  }, []);

  const handleSelect = (id: number) =>
    setSelectedIds((prev: number[]) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );

  const handleDelete = (id: number) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleOpenEditModal = (id?: number) => {
    navigate(
      `${location.pathname}?activeModal=${ModalTypes.channels}&entityId=${id}`,
    );
    dispatch(openModal({ activeModal: ModalTypes.channels }));
  };

  const handleOpenCreateModal = () => {
    navigate(`${location.pathname}?activeModal=${ModalTypes.channels}`);
    dispatch(openModal({ activeModal: ModalTypes.channels }));
  };

  const tableData = list.map(({ id, title, type, isActive }) => ({
    id,
    title,
    type,
    isActive,
  }));

  return (
    <div className="page-list-wrapper">
      <div className="page-list-header">
        <div className="page-list-header--box">
          <ActionBtn
            txt={t("newChannel")}
            handleClick={handleOpenCreateModal}
          />
        </div>
        <div className="page-list-header--box page-list-header--box--right">
          <RefreshButton
            position="right"
            disabled={true}
            isLoading={false}
            onClick={() => {}}
          />
        </div>
        <div className="page-list-header--box page-list-header--box-actions" />
      </div>

      {isLoading ? (
        <DataTableSkeleton columnsCount={6} rowsCount={7} />
      ) : list.length === 0 ? (
        <EmptyState message={t("noSupportChannelsFound")} />
      ) : (
        <div className="game-table-wrap">
          <Table
            data={tableData as Array<Channel & { id: number }>}
            idField="id"
            selectedItems={selectedIds}
            onAllSelect={() => {}}
            onSelect={handleSelect}
            onEdit={(id) => handleOpenEditModal(id)}
            onSort={(id) => (id ? (id) : {})}
            hasDelete
            onDelete={handleDelete}
          />
        </div>
      )}
    </div>
  );
};

export default ChannelsList;
